export const fonts = {
  logo: "'Playfair Display', serif",
  heading: "'Caveat', cursive",
  button: "'Quicksand', sans-serif",
  body: "'Quicksand', sans-serif",
};
